import { COLORS, FONTS } from '../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => {
  // take mobile-first approach to do the styling

  const minSm = theme.breakpoints.up('sm');

  return {
    root: {
      backgroundColor: COLORS.WHITE,
      padding: '40px 0 0 0',
      marginTop: 56,
      [minSm]: {
        marginTop: 64,
        marginLeft: 200,
        width: 'calc(100vw - 200px)',
      },
    },
    innerWrapper: {
      maxWidth: 1200,
      margin: '0 auto',
    },
    headingContainer: {
      display: 'flex',
    },
    heading: {
      display: 'inline-block',
      fontFamily: FONTS.SECONDARY,
      color: COLORS.GREY_DARK,
      fontWeight: 100,
      margin: '0 0 40px 0',
      padding: '0 16px',
      [minSm]: {
        padding: '0 20px 0 30px',
      },
    },
    nav: {
      fontFamily: FONTS.PRIMARY,
      fontSize: '0.725rem',
      listStyle: 'none',
      textTransform: 'uppercase',
      margin: 0,
      padding: '0 16px',

      '& li': {
        display: 'inline-block',
        marginRight: 20,
        '& a': {
          color: COLORS.GREY_DARK,
          textDecoration: 'none',
          fontWeight: 500,
          letterSpacing: '1.5px',
          display: 'block',
          paddingBottom: 10,
        },
      },
      [minSm]: {
        fontSize: '0.875rem',
        padding: '0 30px',
        '& li': {
          marginRight: 30,
        },
      },
    },
    activeLink: {
      borderBottom: `4px solid ${COLORS.GREEN}`,
    },
    approvalStatus: {
      fontFamily: FONTS.PRIMARY,
      fontSize: '0.9rem',
      color: COLORS.BLACK,
      backgroundColor: '#FBB52E',
      display: 'none', // hide on mobile
      alignItems: 'center',
      height: 'fit-content',
      minWidth: 160,
      borderRadius: '20px',
      padding: '1px 8px 2px 14px',
      marginRight: '1rem',
      marginTop: 5,
      [minSm]: {
        marginRight: '2rem',
        display: 'inline-flex', // show for small and up
      },
      // label
      '& > span:first-child': {
        flex: '1',
        marginRight: 5,
      },
      // icon
      '& > span:last-child': {
        flex: '0 1',
      },
      '& > span > svg': {
        fontSize: '1.25rem',
        marginTop: 4,
      },
    },
    blockedStatus: {
      fontFamily: FONTS.PRIMARY,
      fontSize: '0.9rem',
      color: COLORS.BLACK,
      backgroundColor: '#F44336',
      display: 'none', // hide on mobile
      alignItems: 'center',
      height: 'fit-content',
      minWidth: 160,
      borderRadius: '20px',
      padding: '1px 8px 2px 14px',
      marginRight: '1rem',
      marginTop: 5,
      [minSm]: {
        marginRight: '2rem',
        display: 'inline-flex', // show for small and up
      },
      // label
      '& > span:first-child': {
        flex: '1',
        marginRight: 5,
      },
      // icon
      '& > span:last-child': {
        flex: '0 1',
      },
      '& > span > svg': {
        fontSize: '1.25rem',
        marginTop: 4,
      },
    },
  };
};

export default styles;
